import { Component,Input,OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.dev';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { MaskingHelper } from '../../helpers/MaskingHelper';


enum HearAboutPTCCheckBoxType {
  AnotherPtcMember = 1,
  InternetSearch = 2,
  NCMS = 4,
  Other = 8,
  NONE = 0,
}
interface Item {
  text: string;
  value: number;
}

@Component({
    selector: 'download-enrollment-profile',
    templateUrl: './download-enrollment-profile.component.html',
    styleUrls: ['./download-enrollment-profile.component.scss'],
    standalone: false
})


export class DownloadEnrollmentProfileComponent implements OnInit {
  // @Input() CustomerId:any;
  @Input() CustomerData:any;

  CustomerIdEdit :any;


  private customerById_sub: Subscription | any;
  customerByIdData: any = {};
  AffiliatedCompanyName:any;
  ReinstatedAccountNumber:any;
  InvoiceNumber:any='';
  public displayData: any;
  EnrollmentStatusForResendEmail : string= '' ;
  public CompanyName: any = '';
  TotalEmployees: number = 0;
  AnnualEmployeeFee: number = 0;
  SalesTaxPercent: number = 6.5;
  MaxEmployees: number = 200;
  StateSouthDakota: string = 'South Dakota';
  SalesTax: number = 0;
  EnrollmentTotal: number = 0;
  HearAboutValue: any;
  public FederalPrgramsSelected: string = '';
  ProgramsRequested: any = '';
  public ClientProgramSelected: String = '';
  lstHearAboutPTCCheckBoxType: any = [
    { item: 'Another Ptc Member', value: 1, isSelected: false },
    { item: 'Internet Search', value: 2, isSelected: false },
    { item: 'NCMS', value: 4, isSelected: false },
    { item: 'Other', value: 8, isSelected: false },
  ];

  lstCheckBoxFederalProgramTypes: any = [
    { item: 'PHMSA', value: 1, isSelected: false },
    { item: 'FMCSA', value: 2, isSelected: false },
    { item: 'FRA', value: 4, isSelected: false },
    { item: 'FAA', value: 8, isSelected: false },
    { item: 'USCG', value: 16, isSelected: false },
  ];

  lstCheckBoxClientRequiremets: any = [
    { item: 'Branch Energy', value: 1, isSelected: false },
    { item: 'Conoco Phillips', value: 2, isSelected: false },
    { item: 'Enbridge', value: 4, isSelected: false },
    { item: 'Enterprise', value: 8, isSelected: false },
    { item: 'ExxonMobil', value: 16, isSelected: false },
    { item: 'Imperial Oil', value: 32, isSelected: false },
    { item: 'Jonah Energy', value: 64, isSelected: false },
    { item: 'NuStar Energy', value: 128, isSelected: false },
    { item: 'SeaRiver', value: 256, isSelected: false },
    { item: 'XTO', value: 512, isSelected: false },
  ];
  public DrugTestPanelItems: Array<Item> = [
    { text: 'DOT Look-a-like Panel', value: 0 },
    { text: '9-Panel (most common)', value: 1 },
    { text: 'Other Panel (please contact PTC for specifics)', value: 2 },
  ];
  AckAndAgreementValue: any;
  AckDate: any;
  objProgramSelection: any;
  public DrugTestPanelValue: any;


  constructor( private http: HttpClient,
    public datePipe: DatePipe,
    private MaskingHelper: MaskingHelper
    ) { }
  
  ngOnInit(): void {
    this.View(this.CustomerData)
  }

  View = async (CustomerData: any) => {
    this.CustomerIdEdit = ' added';
   
    // this.customerById_sub = this.getCustomersById(id)
    //   .subscribe((resp: any) => {
        // this.customerByIdData = resp;
        this.customerByIdData = CustomerData
        // console.log("Receive data from api CustomerData");
        // console.log(JSON.stringify(CustomerData));
        // console.log("Receive data from api CustomerDetail");
        // console.log(JSON.stringify(this.CustomerData));
        this.AffiliatedCompanyName = this.customerByIdData.JSONCustomerDetails.CompanyDetails.AffiliatedCompanyName;
        this.ReinstatedAccountNumber = this.customerByIdData.JSONCustomerDetails.CompanyDetails.ReinstatedAccountNumber;
        this.InvoiceNumber = this.customerByIdData.JSONCustomerDetails.InvoiceNumber;
        
        // console.log(this.customerByIdData);
        if (this.customerByIdData.JSONNotesDetails.length == 1 && this.customerByIdData.JSONNotesDetails[0].Notes == "") {
          this.displayData = [];
        }
        else {
          this.displayData = this.customerByIdData.JSONNotesDetails;
        }
        this.displayData.reverse();
        this.EnrollmentStatusForResendEmail = this.customerByIdData.EnrollmentStatus;
        this.CompanyName = this.customerByIdData.CompanyName;
        try {
          this.TotalEmployees =
            this.customerByIdData.JSONCustomerDetails.PTCProgramDetails
              .FederalProgram.NumberOfEmployees +
            this.customerByIdData.JSONCustomerDetails.PTCProgramDetails
              .CompanyProgram.NumberOfEmployees +
            this.customerByIdData.JSONCustomerDetails.PTCProgramDetails
              .OtherProgram.NumberOfEmployees;
        } catch { }

        try {
          this.AnnualEmployeeFee = (this.customerByIdData.JSONCustomerDetails.FeeDetails.AnnualEmployeeFee * (this.TotalEmployees >= this.MaxEmployees ? this.MaxEmployees : this.TotalEmployees))

          let EnrollmentTotalFee = this.customerByIdData.JSONCustomerDetails.FeeDetails.SetupFee + this.customerByIdData.JSONCustomerDetails.FeeDetails.AnnualSubscription + (this.AnnualEmployeeFee + this.customerByIdData.JSONCustomerDetails.FeeDetails.ExpeditedShippingFee);

          this.SalesTax = EnrollmentTotalFee * this.SalesTaxPercent * 0.01;

          this.EnrollmentTotal = (EnrollmentTotalFee + this.SalesTax).toFixed(2);

        }
        catch { }
       
        
        
      

        let valueHearAbout = this.customerByIdData.JSONCustomerDetails.CompanyDetails.HearAboutPTC;
        if (valueHearAbout === 0) {
          this.HearAboutValue = HearAboutPTCCheckBoxType[HearAboutPTCCheckBoxType.NONE];
        } else {
          this.HearAboutValue = this.GetTextSelectedList(
            valueHearAbout,
            this.lstHearAboutPTCCheckBoxType
          );
        }


        this.AckAndAgreementValue =
          this.customerByIdData.JSONCustomerDetails.AckAndAgreement;
        // console.log(this.AckAndAgreementValue);
        this.AckDate = this.datePipe.transform(
          this.AckAndAgreementValue.AckDate,
          'MM/dd/yyyy'
        );
        this.AckDate = this.AckDate == "01/01/0001" ? "" : this.AckDate;
        let FedralProgramsValues =
          this.customerByIdData.JSONCustomerDetails.PTCProgramDetails
            .FederalProgram.FederalPrograms;

        this.FederalPrgramsSelected = this.GetTextSelectedList(
          FedralProgramsValues,
          this.lstCheckBoxFederalProgramTypes
        );

        this.GetProgramsRequested(
          this.customerByIdData.JSONCustomerDetails.DefaultFederalProgramType
        );

        this.ClientProgramSelected = this.GetTextSelectedList(
          this.customerByIdData.JSONCustomerDetails.PTCProgramDetails
            .OtherProgram.OtherPrograms,
          this.lstCheckBoxClientRequiremets
        );

        this.lstCheckBoxClientRequiremets = this.GetCheckBoxList(
          this.customerByIdData.JSONCustomerDetails.PTCProgramDetails
            .OtherProgram.OtherPrograms,
          this.lstCheckBoxClientRequiremets
        );

        let DrugTestPanelApi =
          this.customerByIdData.JSONCustomerDetails.PTCProgramDetails
            .CompanyProgram.DrugTestPanel;

        this.DrugTestPanelValue = this.DrugTestPanelItems.filter(
          (_) => _.value == DrugTestPanelApi
        )[0].text;

      
        this.objProgramSelection = this.GetSelectedListProgramInfo(this.customerByIdData.JSONCustomerDetails.DefaultFederalProgramType, this.objProgramSelection);
        //this.requestEnded();
      // });
  };



  getCustomersById(id: any) {
    let options = {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }
    return this.http.get(environment.baseUrl + `/CustomerDetails/${id}`,options);
  }


  GetTextSelectedList(FedralProgramsValues: any, lstCheckBox: any) {
    let RemainingValues = FedralProgramsValues;
    let FederalProgramTextList = [];
    for (let i = lstCheckBox.length - 1; i >= 0; i--) {
      if (RemainingValues - lstCheckBox[i].value >= 0) {
        FederalProgramTextList.push(lstCheckBox[i].item);
        RemainingValues = RemainingValues - lstCheckBox[i].value;
      }
    }

    let PrgramSelected = '';
    for (let i = FederalProgramTextList.length - 1; i >= 0; i--) {
      if (PrgramSelected != '') {
        PrgramSelected += ', ';
      }
      PrgramSelected += FederalProgramTextList[i];
    }
    return PrgramSelected;
  }

  GetProgramsRequested(FedralProgramsValues: any) {
    let RemainingValues = FedralProgramsValues;

    let lstProgramsRequested= [];

    if (RemainingValues - 4 >= 0) {
      lstProgramsRequested.push('Client Required');      
      RemainingValues = RemainingValues - 4;
    }

    if (RemainingValues - 2 >= 0) {
      lstProgramsRequested.push('Non-DOT (Company)');     
      RemainingValues = RemainingValues - 2;
    }

    if (RemainingValues - 1 >= 0) {
      lstProgramsRequested.push('DOT (' + this.FederalPrgramsSelected + ')');     
      RemainingValues = RemainingValues - 1;
    }

    this.ProgramsRequested = lstProgramsRequested.reverse().join(',');
  }


  
  GetCheckBoxList(FedralProgramsValues: any, lstCheckBox: any) {
    let RemainingValues = FedralProgramsValues;

    for (let i = lstCheckBox.length - 1; i >= 0; i--) {
      if (RemainingValues - lstCheckBox[i].value >= 0) {
        lstCheckBox[i].isSelected = true;
        RemainingValues = RemainingValues - lstCheckBox[i].value;
      } else {
        lstCheckBox[i].isSelected = false;
      }
    }

    // let PrgramSelected = '';
    // for (let i = FederalProgramTextList.length - 1; i >= 0; i--) {
    //   if (PrgramSelected != '') {
    //     PrgramSelected += ', ';
    //   }
    //   PrgramSelected += FederalProgramTextList[i];
    // }
    return lstCheckBox;
  }

  GetSelectedListProgramInfo(FedralProgramsValues: any, lstCheckBox: any) {
    let RemainingValues = FedralProgramsValues;

    if (RemainingValues - 4 >= 0) {
      lstCheckBox.ClientRequired = true;
      RemainingValues = RemainingValues - 4;
    }

    if (RemainingValues - 2 >= 0) {
      lstCheckBox.NonDotCompnay = true;
      RemainingValues = RemainingValues - 2;
    }

    if (RemainingValues - 1 >= 0) {
      lstCheckBox.DotFederal = true;
      RemainingValues = RemainingValues - 1;
    }
    return lstCheckBox;
  }

  GetPhoneNoFormat(PhoneNo: string) {
    return this.MaskingHelper.GetPhoneNoFormat(PhoneNo);
  }

  GetFaxNoFormat(FaxNo: string) {
    return this.MaskingHelper.GetFaxNoFormat(FaxNo);
  }

  GetZipFormat(Zip: string) {
    return this.MaskingHelper.GetZipFormat(Zip);
  }
  GetFederalTaxFormat(Tax: string) {
    return this.MaskingHelper.GetFederalTaxFormat(Tax);
  }

  GetISNFormat(Tax: string) {
    return this.MaskingHelper.GetISNFormat(Tax);
  }
  

}
